import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=4a2ed436&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2ed436')) {
      api.createRecord('4a2ed436', component.options)
    } else {
      api.reload('4a2ed436', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=4a2ed436&", function () {
      api.rerender('4a2ed436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/Logo.vue"
export default component.exports